import React, { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
// import Notification from "rc-notification";
import axios from "axios";
import { ModalUsePortal } from "../../components/ModalUsePortal";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import "./styles.less";

import { contactUs } from "../../utils/contactUs";
import { partnerInfo } from "../../utils/partnerInfo";

export const PartnerFormModal = (props) => {
  const { visible, setVisible } = props;
  const { handleSubmit, register, errors, reset, getValues } = useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [showNotice, setShowNotice] = useState(false);
  const [userPhone, setUserPhone] = useState(null);

  const onSubmit = async (values) => {
    setLoading(true);
    console.log(values, "values");
    try {
      // 荟聚
      //   await connecttHuiju(clueValues);
      //   // 飞书通知
      //   await contactUs(clueValues);
      await partnerInfo(values);

      // if (res.code === 200) {
      // setVisible(false);

      setLoading(false);
      // connecttHuiju(clueValues); // 荟聚咨询表单线索追踪事件
      setShowNotice(true);
      reset();
      // }
    } finally {
      // setVisible(false);
      setLoading(false);
      setShowNotice(true);
    }
  };

  const onError = (errors, e) => {
    console.log(errors);
  };

  const notice = () => {
    return (
      <div className="notice-block">
        <div className="notice-title">{t("common.form.success-tip")}</div>
        <div
          className="notice-close"
          onClick={() => {
            setVisible(false);
            setLoading(false);
            setShowNotice(false);
          }}
        >
          <i className="icon authing-icon authing-guanbi"></i>
        </div>
        <div className="notice-img">
          <img
            src="//files.authing.co/authing-website/consult-form-img.png"
            alt="authing"
          />
        </div>
        <div className="notice-img-tip">
          {t("common.form.success-wait-tip")}
        </div>
        {/* <div className="notice-try-tip">{t("common.form.success-try-tip")}</div> */}
      </div>
    );
  };
  const form = () => {
    return (
      <div className="consult-form">
        <div className="form-top">
          <div className="form-title">{t("partner.form.title")}</div>

          <div
            className="form-close"
            onClick={() => {
              setVisible(false);
              setLoading(false);
              setShowNotice(false);
            }}
          >
            <i className="icon authing-icon authing-guanbi"></i>
          </div>
        </div>

        <form onSubmit={handleSubmit(onSubmit, onError)}>
          <div className="form-item">
            <div className="input">
              <Input
                name="company"
                error={errors.company}
                placeholder={t("partner.form.company")}
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /^[^\s]*$/,
                    message: "error message",
                  },
                })}
              />
            </div>
          </div>
          <div className="form-item">
            <div className="input">
              <Input
                name="email"
                placeholder={t("partner.form.email")}
                inputRef={register()}
              />
            </div>
          </div>
          <div className="form-item">
            <div className="input">
              <Input
                name="address"
                error={errors.address}
                placeholder={t("partner.form.address")}
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /^[^\s]*$/,
                    message: "error message",
                  },
                })}
              />
            </div>
          </div>
          <div className="form-item">
            <div className="input">
              <Input
                error={errors.name}
                placeholder={t("partner.form.name")}
                name="name"
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /^[^\s]*$/,
                    message: "error message",
                  },
                })}
              />
            </div>
          </div>
          <div className="form-item">
            <div className="input">
              <Input
                name="phone"
                error={errors.phone}
                placeholder={t("partner.form.phone")}
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /^1[3-9]\d{9}$/,
                    message: "error message",
                  },
                })}
              />
            </div>
          </div>

          <div className="form-item">
            <div className="input">
              <Input
                name="intend"
                placeholder={t("partner.form.intend")}
                error={errors.intend}
                inputRef={register({
                  required: true,
                  pattern: {
                    value: /^[^\s]*$/,
                    message: "error message",
                  },
                })}
              />
            </div>
          </div>
          <div className="form-item">
            <Button type="submit" className="consult-submit" disabled={loading}>
              {loading ? (
                <ReactLoading
                  type={"spin"}
                  height={20}
                  width={20}
                  delay={0}
                  className={"spin-loading"}
                />
              ) : (
                ""
              )}
              {t("common.form.submit")}
            </Button>
          </div>
        </form>
        {/* <div className="form-bottom">
          <div>{t("common.form.otherTip")}</div>
          <div>
            {t("common.form.otherTip1")}
            <span className="count">400 888 2106</span>
            {t("common.form.otherTip2")}
          </div>
        </div> */}
      </div>
    );
  };
  return (
    <ModalUsePortal show={visible}>
      <div className="partner-form-modal">{showNotice ? notice() : form()}</div>
    </ModalUsePortal>
  );
};
